module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/detail/project-detail-objects/import-objects-modal/import-objects-modal.component.scss
// module id = ./src/app/projects/detail/project-detail-objects/import-objects-modal/import-objects-modal.component.scss
// module chunks = main